module.exports = __webpack_public_path__ + "static/media/mazda_logo.d4288180.png";